class Modal3DPreview {
  static loadSpeedBoatViseScript(e, t, o, n, i, l, a, r, d, b, c) {
    const script = document.createElement("script");
    script.src = `https://${o}.componentsearchengine.com/common/plugin.js`;
    script.id = "iframeScript";
    document.body.appendChild(script);
    script.onload = () => window.loadPartDiv(e, t, o, n, i, l, a, r, d, b, c);
  }

  static mvPopState(e) {
    e.state && "MultiView First Shown" == e.state && this.closeMultiViewDiv();
  }

  static mvBack() {
    window.history.back();
  }

  static closeMultiViewDiv(e) {
    let t = document.getElementById("mvBackdrop");
    null !== t && t.parentNode.removeChild(t),
      window.removeEventListener("resize", this.backdropResized),
      window.removeEventListener("popstate", this.mvPopState),
      "undefined" != typeof breMainAreaResized &&
        window.removeEventListener("resize", breMainAreaResized);
  }

  static mvNoAction(e) {
    e.stopPropagation();
  }

  static backdropResized(e) {
    let t = 0.9 * document.getElementById("mvBackdrop").clientWidth,
      o = Math.min(t, 842),
      n = document.getElementById("mvOverlayDiv"),
      i = document.getElementById("mvActiveArea");
    n.style.width = o + "px";
    let l = Math.min(0.95 * window.innerHeight - 10, 550);
    (n.style.height = l + "px"),
      (i.style.height = l - 50 + "px"),
      (i.style.overflowY = "hidden");
  }

  static in_array(e, t) {
    for (let o in t) if (t[o] == e) return !0;
    return !1;
  }
}

export default Modal3DPreview;
